import { HTMLInputAutoCompleteAttribute } from 'react';
import {
	STANDARD_INPUT_HORIZONTAL_PADDING_CLASSNAME,
	STANDARD_INPUT_TEXT_SIZE_CLASSNAME,
	STANDARD_INPUT_VERTICAL_PADDING_CLASSNAME,
} from 'src/components/primitives/Input/consts';
import { InputSize } from 'src/components/primitives/Input/types';

const AUTOCOMPLETE_OFF_PROPS = {
	autoComplete: 'off',
	/**
	 * data-form-type is necessary to disable autocomplete for Dashlane.
	 */
	'data-form-type': 'other',
};

export function getAutoCompleteProps(
	autoComplete: HTMLInputAutoCompleteAttribute | undefined
) {
	// Autocomplete is off by default, need to opt-in otherwise the OFF PROPS are applied
	return !autoComplete || autoComplete === 'off'
		? AUTOCOMPLETE_OFF_PROPS
		: { autoComplete };
}

export function getInputSizeDependentClassName(size?: InputSize) {
	if (!size) {
		return {
			paddingClassName: undefined,
			textSizeClassName: undefined,
		};
	}

	const paddingClassName = [
		STANDARD_INPUT_VERTICAL_PADDING_CLASSNAME[size],
		STANDARD_INPUT_HORIZONTAL_PADDING_CLASSNAME[size],
	];
	const textSizeClassName = STANDARD_INPUT_TEXT_SIZE_CLASSNAME[size];

	return {
		paddingClassName,
		textSizeClassName,
	};
}
